import React from 'react';

function BancoModal({ show, onClose, onSubmit, form, handleChange, title = 'CADASTRO DE BANCO' }) {
  if (!show) return null;
  return (
    <div className="modal show d-block" tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-bank me-2"></i>{title}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={onSubmit}>
              <div className="mb-3">
                <label className="form-label">Código *</label>
                <input type="text" className="form-control" name="id" value={form.id} onChange={handleChange} required />
              </div>
              <div className="mb-3">
                <label className="form-label">Nome *</label>
                <input type="text" className="form-control" name="nome" value={form.nome} onChange={handleChange} required />
              </div>
              <div className="d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                <button type="submit" className="btn btn-success">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BancoModal;
